export default "__VITE_ASSET__DccdE95Y__"